import {IService} from "@/model/Service/Service"

export interface IHasServices {
    getServices(): IService[]
    getServicesMap(): Map<string, IService>
    addService(service: IService): void
    removeService(service: IService): void
}

function hasServices<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServices {
        private services: IService[] = []
        private servicesMap: Map<string, IService> = new Map()

        constructor(...args: any[]) {
            super(...args);
        }

        public getServices(): IService[] {
            return this.services
        }
        public getServicesMap(): Map<string, IService> {
            return this.servicesMap
        }
        public addService(service: IService): void {
            if (this.servicesMap.has(service.getIdFull())) return
            this.services.push(service)
            this.servicesMap.set(service.getIdFull(), service)
        }
        public removeService(service: IService): void {
            if (!this.servicesMap.has(service.getIdFull())) return
            this.services = this.services.filter((existingService: IService) => existingService.getIdFull() !== service.getIdFull())
            this.servicesMap.delete(service.getIdFull())
        }
    };
}

export default hasServices